import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "displayFormat"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/InputText/MaskedInput.js",
  _this = this;
import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';
import FormInput from '../../core/components/Forms/FormInput';
import supportedFormats from './supportedFormats';
/**
 * Using wrapper to convert the component to a stateful component.
 * This is a workaround for a known issue. backspace does not update the display correctly.
 * https://github.com/text-mask/text-mask/issues/480
 *
 */

var StatefulMaskedInput = function StatefulMaskedInput(_ref) {
  var _onChange = _ref.onChange,
    displayFormat = _ref.displayFormat,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(props.value),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  return /*#__PURE__*/React.createElement(MaskedInput, _extends({}, props, {
    value: props.value || value,
    onChange: function onChange(e) {
      setValue(e.target.value);
      return _onChange && _onChange(e, _unmask(e.target.value));
    },
    guide: false,
    mask: supportedFormats[displayFormat],
    render: function render(ref, inputProps) {
      return /*#__PURE__*/React.createElement(FormInput, _extends({}, props, inputProps, {
        as: "input",
        ref: ref,
        type: remapInputType(props.type, displayFormat) || 'text',
        disabled: props.disabled,
        error: props.error,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27,
          columnNumber: 9
        }
      }));
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }));
};
var remapInputType = function remapInputType(type, displayFormat) {
  if ('date' === displayFormat) return 'text';else return type;
};
export default StatefulMaskedInput;
/**
 *
 * @param {String} value formatted value
 * @return {string}
 * @private
 */

export var _unmask = function _unmask(value) {
  return value.replace(/( |\/|\+65)/g, '');
};